import config from '@/config/config'

// eslint-disable-next-line no-shadow
export enum LogLevel {
  TRACE = 'trace',
  DEBUG = 'debug',
  INFO = 'info',
  LOG = 'log',
  WARN = 'warn',
  ERROR = 'error',
}

const environment = (
  config.application.environment === 'DEV'
    ? 'CDT'
    : config.application.environment
).toLowerCase()

const telemetryConfig = {
  app: {
    name: `anl-vendor-frontend-${environment}`,
    version: process.env.NEXT_PUBLIC_APPLICATION_VERSION,
    environment,
  },
  apiKey: config.telemetry.apiKey,
  useSendBeacon: false,
  traceLog: false,
  debug: false,
  performanceInstrument: {ignoreEvents: ['msal.*']},
  instrumentations: {
    xhr: false,
    fetch: false,
    interactions: false,
    errors: false,
  },
}

export default telemetryConfig
